export default __webpack_public_path__ + "c8a6c7af3db4b7521a9ca72cb0d9b486.wav";